// Lazy photo tokens — detail loads replace base64 photos with
// "psc-lazy://item/idx/hash" tokens; each real photo is fetched on demand.
import api from "@/lib/api";

export const LAZY_PREFIX = "psc-lazy://";
export const isLazyPhoto = (src) => typeof src === "string" && src.startsWith(LAZY_PREFIX);

const cache = new Map();
const pending = new Map();

export const resolveLazyPhoto = async (inspectionId, token) => {
  if (!isLazyPhoto(token)) return token;
  const key = `${inspectionId}|${token}`;
  if (cache.has(key)) return cache.get(key);
  if (pending.has(key)) return pending.get(key);
  const parts = token.slice(LAZY_PREFIX.length).split("/");
  const h = parts.pop();
  const idx = parts.pop();
  const item = parts.join("/");
  const p = api
    .get(`/inspections/${inspectionId}/lazy-photo`, { params: { item, idx, h } })
    .then((r) => { cache.set(key, r.data.photo); pending.delete(key); return r.data.photo; })
    .catch((e) => { pending.delete(key); throw e; });
  pending.set(key, p);
  return p;
};

// Resolve every token in an items map (used before zipping photos etc.)
export const resolveAllLazyPhotos = async (inspectionId, items) => {
  const out = {};
  for (const [k, v] of Object.entries(items || {})) {
    const photos = v?.photos || [];
    if (photos.some(isLazyPhoto)) {
      const resolved = await Promise.all(photos.map(async (p) => {
        try { return await resolveLazyPhoto(inspectionId, p); } catch { return null; }
      }));
      out[k] = { ...v, photos: resolved.filter(Boolean) };
    } else {
      out[k] = v;
    }
  }
  return out;
};
